import { getPlayerStore, PlayerType } from "../../model";

export const usePlayerAllActions = (type: PlayerType) => {
  const store = getPlayerStore(type);
  return {
    ...store.playerActions,
    ...store.miniActions,
    ...store.downloadActions,
    ...store.controlsActions,
  };
};
